import { render, staticRenderFns } from "./SeasonalIndicatorSetup.vue?vue&type=template&id=31ed4ab6&scoped=true&"
import script from "./SeasonalIndicatorSetup.vue?vue&type=script&lang=js&"
export * from "./SeasonalIndicatorSetup.vue?vue&type=script&lang=js&"
import style0 from "./SeasonalIndicatorSetup.vue?vue&type=style&index=0&id=31ed4ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed4ab6",
  null
  
)

export default component.exports